import React, { useEffect, useState } from "react"
import { Pause, Play } from "react-feather"
import { useDispatch, useSelector } from "react-redux"
import { Card, Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"
import { endOfHalftime, toggleOvertime } from "../../redux/actions/actions"
import { getCurrentTime } from "../../utility/Utils"
import styles from "./TimeBar.module.scss"
import { getSportsConfig } from "../../utility/constants/sportConfig"
import EndButton from "../EndButton"
import { toggleTime } from "../../api/socket/functions"

function TimeBar() {
	const dispatch = useDispatch()
	const spectate = localStorage.getItem("spectate")
	const isDone = localStorage.getItem("isDone")

	const { numOfHalftimes, overtimeMinutes } = getSportsConfig(
		localStorage.getItem("sport")
	)
	const halftimeLength = localStorage.getItem("halftime")
	const halftimeName =
		numOfHalftimes === 2
			? "Poluvrijeme (H)"
			: numOfHalftimes === 4
			? "Četvrtina (Q)"
			: "Dio (D)"

	const { timeState, penaltiesOrEnd } = useSelector((state) => {
		return { timeState: state.time, penaltiesOrEnd: state.penaltiesOrEnd }
	})

	const [time, setTime] = useState(getCurrentTime(timeState))
	const [isOpen, setIsOpen] = useState(false)

	const inOvertime = overtimeMinutes && timeState.overtime

	useEffect(() => {
		const myInterval = setInterval(() => {
			if (timeState.isPaused) {
				clearInterval(myInterval)
			} else {
				const time = getCurrentTime(timeState)

				if (inOvertime) {
					if (
						parseInt(overtimeMinutes) <=
						parseInt(
							time.halftime.substring(0, time.halftime.indexOf(":"))
						)
					) {
						dispatch(toggleOvertime(true))
					}
				} else {
					if (
						parseInt(halftimeLength) <=
						parseInt(
							time.halftime.substring(0, time.halftime.indexOf(":"))
						)
					) {
						dispatch(endOfHalftime())
					}
				}
				setTime(time)
			}
		}, 1000)

		return () => clearInterval(myInterval)
	}, [timeState.isPaused])

	const onTogglePause = (value) => {
		if (timeState.notStarted && timeState.halftime === numOfHalftimes) {
			setIsOpen(!isOpen)
		}
		toggleTime({ isPaused: value })
	}

	const createModalIfOvertime = () => {
		return (
			<Modal
				className="modal-dialog-centered"
				isOpen={isOpen}
				toggle={() => setIsOpen(false)}
			>
				<ModalHeader toggle={() => setIsOpen(false)}>
					Prvo započni produžetak
				</ModalHeader>
				<ModalBody>
					Ako želiš pritisnuti play, moraš prvo započeti produžetak
				</ModalBody>
				<ModalFooter>
					<Button.Ripple
						color="secondary"
						onClick={() => setIsOpen(false)}
					>
						Odustani
					</Button.Ripple>
				</ModalFooter>
			</Modal>
		)
	}

	return (
		<Card className={styles.wrapper}>
			{createModalIfOvertime()}
			{!spectate ? (
				timeState.isPaused ? (
					<Button.Ripple
						color="primary"
						outline
						onClick={() => onTogglePause(false)}
					>
						<Play height="20" />
					</Button.Ripple>
				) : (
					<Button.Ripple
						color="primary"
						outline
						onClick={() => onTogglePause(true)}
					>
						<Pause height="20" />
					</Button.Ripple>
				)
			) : (
				<span></span>
			)}
			<div className={styles.timeBarCenter}>
				<div>
					<h6>Cijelo vrijeme</h6>
					<h4>{time.fulltime}</h4>
				</div>
				{inOvertime ? (
					<>
						<div>
							<h6>Vrijeme Produžetka</h6>
							<h1>
								{time.halftime}
								<span className="h4">/ {overtimeMinutes}:00</span>
							</h1>
						</div>
						<div>
							<h6>Produžetak (O)</h6>
							<h4>{timeState.overtime}</h4>
						</div>
					</>
				) : (
					<>
						<div>
							<h6>Vrijeme Poluvremena</h6>
							<h1>
								{time.halftime}
								<span className="h4">/ {halftimeLength}:00</span>
							</h1>
						</div>
						<div>
							{timeState.halftime < numOfHalftimes ? (
								<>
									<h6>{halftimeName}</h6>
									<h4>
										{`${
											timeState.halftime + 1
										}/${numOfHalftimes}`}
									</h4>
								</>
							) : (
								<h3>Završena utakmica</h3>
							)}
						</div>
					</>
				)}
			</div>
			{!spectate && !isDone && <EndButton penaltiesOrEnd={penaltiesOrEnd} />}
		</Card>
	)
}

export default TimeBar
